/* eslint-disable import/prefer-default-export */
import {
  addPartnerWithApiAccessApi,
  getPartnerCarrierWebhookConfigApi,
  getPartnerPracticesApi,
  getPartnerWorkflowConfigApi,
  getPartnersApi,
  listPartnersApi,
  savePartnerCarrierWebhookConfigApi,
  savePartnerWorkflowConfigApi,
  updatePartnerApi,
  updatePartnerCatalogDefaultsApi,
} from 'api/partner';
import { debounce } from 'lodash';
import { partnerActions } from 'store/slices/partnerSlice';

import { handleError } from './errorHandlerThunks';

export const getPartners = () => (dispatch, getState) => {
  const { currentTenantId } = getState().auth;

  return getPartnersApi()
    .then((partners) => {
      dispatch(partnerActions.loadPartners({ partners, currentTenantId }));
    })
    .catch((error) => dispatch(handleError({ error })));
};

export const getPartnerPractices =
  ({ partnerIds }) =>
  (dispatch, getState) => {
    const { currentTenantId } = getState().auth;

    return getPartnerPracticesApi(partnerIds)
      .then((practices) => {
        dispatch(
          partnerActions.loadPartnerPractices({
            currentTenantId,
            practices,
            partnerIds,
          })
        );

        return practices;
      })
      .catch((error) => {
        dispatch(handleError({ error }));
      });
  };

export const listPartnerProfiles =
  ({ page }) =>
  (dispatch, getState) => {
    const { sortBy, filter } = getState().partner.partnerManagement;
    dispatch(partnerActions.updateCurrentPage({ page }));

    return listPartnersApi({ page, sortBy, filter })
      .then(({ count, result }) => {
        dispatch(partnerActions.listPartnerProfiles({ page, items: result, count }));
      })
      .catch((error) => {
        dispatch(handleError({ error }));
      });
  };

export const debouncedListPartnerProfiles = debounce(({ dispatch }) => {
  return dispatch(listPartnerProfiles({ page: 1 })).finally(() =>
    dispatch(partnerActions.setPartnerProfileLoading(false))
  );
}, 1000);

export const updatePartnerProfileSortBy =
  ({ sortBy }) =>
  (dispatch) => {
    dispatch(partnerActions.updateSortBy({ sortBy }));
    debouncedListPartnerProfiles({ dispatch });
  };

export const updatePartnerProfileFilter =
  ({ filter }) =>
  (dispatch) => {
    dispatch(partnerActions.setPartnerProfileLoading(true));
    dispatch(partnerActions.updateFilter({ filter }));
    debouncedListPartnerProfiles({ dispatch });
  };

export const getPartnerWorkflowConfig = (partnerUUID) => (dispatch) => {
  return getPartnerWorkflowConfigApi(partnerUUID)
    .then((workflowConfig) => workflowConfig)
    .catch((error) => dispatch(handleError({ error })));
};

export const savePartnerWorkflowConfig =
  ({ partnerUUID, input }) =>
  (dispatch) =>
    savePartnerWorkflowConfigApi({ partnerUUID, input })
      .then((workflowConfig) => !!workflowConfig?.partnerWorkflowConfigId)
      .catch((error) => dispatch(handleError({ error })));

export const getPartnerCarrierWebhookConfig = (partnerUuid) => (dispatch) => {
  return getPartnerCarrierWebhookConfigApi(partnerUuid)
    .then((carrierWebhookConfig) => carrierWebhookConfig)
    .catch((error) => dispatch(handleError({ error })));
};

export const savePartnerCarrierWebhookConfig =
  ({ partnerUuid, pickedUp, outForDelivery, delivered }) =>
  (dispatch) =>
    savePartnerCarrierWebhookConfigApi({ partnerUuid, pickedUp, outForDelivery, delivered })
      .then((carrierWebhookConfig) => !!carrierWebhookConfig)
      .catch((error) => dispatch(handleError({ error })));

export const updatePartnerCatalogDefaults = (params) => (dispatch) =>
  updatePartnerCatalogDefaultsApi(params)
    .then((catalogDefaults) => {
      dispatch(
        partnerActions.updatePartnerProfile({
          partnerUuid: params.partnerUuid,
          changes: { newProductsActiveByDefault: catalogDefaults.newProductsActiveByDefault },
        })
      );
      return catalogDefaults;
    })
    .catch((error) => dispatch(handleError({ error })));

export const addPartnerWithApiAccess = (input) => (dispatch, getState) => {
  const { filter } = getState().partner.partnerManagement;

  return addPartnerWithApiAccessApi(input)
    .then((response) => {
      dispatch(updatePartnerProfileFilter({ filter }));
      return response;
    })
    .catch((error) => dispatch(handleError({ error })));
};

export const updatePartner =
  ({ partnerUuid, data }) =>
  (dispatch, getState) => {
    const { filter } = getState().partner.partnerManagement;

    return updatePartnerApi({ partnerUuid, data })
      .then((response) => {
        dispatch(updatePartnerProfileFilter({ filter }));
        return response;
      })
      .catch((error) => dispatch(handleError({ error })));
  };

export const updatePartnerWithoutRefresh =
  ({ partnerUuid, data }) =>
  (dispatch) => {
    return updatePartnerApi({ partnerUuid, data })
      .then((response) => {
        return response;
      })
      .catch((error) => dispatch(handleError({ error })));
  };
